import React, { Component } from 'react'

import { connect } from 'react-redux'
//公共组件
import preload from 'components/enhancer/preload'//服务器端加载
//added chinatopcredit.com
import { QuickBorrow} from './QuickBorrow';
import { Product } from './Product'
import { Saas } from './Saas'
import { News } from './News';
// import { CooperateStructures } from './CooperateStructures';
import { About } from './About'
import './Home.css'//样式
import Meta from 'components/layout/Meta';

function Home(props) {//此方式职能使用props，不能this.props.
  return (
    <div>
      <Meta location={props.location} title=""/>
      <QuickBorrow banner={props.banner}/>
      <Product/>
      <Saas/>
      <News news={props.news} homeNews={props.homeNews} menuChilderUrl={menuChilderUrl}/>
      {/* <CooperateStructures /> */}
      <About/>
    </div>
  )
}

const menuChilderUrl=(catname,childCatname,page='')=>{
  let locations=window.location && window.location.host.split('.')
  let pageUrl=(page!='' && (childCatname=='newsdetail' || childCatname=='loaninfodetail'))?'/show-'+page+'.html': (childCatname=='news' || childCatname=='loaninfo')?'/list-1.html':''
  let childerUrl=''
  childerUrl='/' +catname+ '/' +(childCatname=='newsdetail'?'news':(childCatname=='news'?'newsinfo':childCatname))
  if((locations && !/^(ztx-uat|ztx-sit|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地
    return 'https://'+prefixUrlChilder(childCatname)+".ctcfin.com"+childerUrl+pageUrl
  }else{
    return catname!=''?(childerUrl+pageUrl):'/'
  }
}
const prefixUrlChilder=(catname)=>{
  switch (catname){
    default :
      return 'www'
  }
}
// Home.left = Logo
Home.breadcrumb = false

Home = connect(state => {//redux绑定
  return {
    banner: state.common.banner,//产品广告位
    homeNews: state.common.homeNews,//首页新闻中心带图片新闻
    news:state.home.news,//新闻
  }
})(Home)//redux链接组件

Home = preload(function({dispatch, getState}) {//服务器端预加载数据
  const promises = [//数组
    //  dispatch(getProductAdPanel('banner')),//banner
    // dispatch(getHomeConfigs()),//产品广告
  ]
  return Promise.all(promises).catch(console.error)
}, Home)

export { Home }//被增强的修饰的react



// WEBPACK FOOTER //
// ./modules/home/Home.js